import { FoodsBadge } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type OverviewHeaderProps = {
    ssqsCount?: number | undefined | null;
};
export const OverviewHeader = (props: OverviewHeaderProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const { ssqsCount = 0 } = props;

    const datavizColor = theme.custom.dataviz.colorsWithExtra[4];

    return (
        <Stack flexDirection={"row"} gap={theme.spacing(2)} justifyContent={"space-between"} alignItems={"center"}>
            <Stack flexDirection="row" gap={theme.spacing(1)}>
                <FoodsBadge
                    size={5}
                    icon={"diagnostic"}
                    boxProps={{
                        sx: {
                            padding: theme.spacing(1),
                            color: datavizColor.variant[700],
                            backgroundColor: datavizColor.variant[100],
                            borderRadius: "8px",
                        },
                    }}
                />
                <Typography variant="h3" alignSelf={"center"}>
                    {t("company.overview.questionnaire_title", "Mes questionnaires")}
                </Typography>
                {ssqsCount !== null && ssqsCount >= 4 && (
                    <>
                        <Typography variant="huge" alignSelf={"center"}>
                            {"-"}
                        </Typography>
                        <Typography variant="huge" alignSelf={"center"} sx={{ transform: "translateY(0.5px)" }}>
                            {`${ssqsCount}`}
                        </Typography>
                    </>
                )}
            </Stack>
        </Stack>
    );
};
